import { render } from "./LandingPageCard.vue?vue&type=template&id=06e2639e&scoped=true"
import script from "./LandingPageCard.vue?vue&type=script&lang=js"
export * from "./LandingPageCard.vue?vue&type=script&lang=js"

import "./LandingPageCard.vue?vue&type=style&index=0&id=06e2639e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e2639e"]])

export default __exports__